import React from "react";
// import { useState } from "react";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";
import Sidebar from "./sidebar.js";



const Header = () => {
  // const [menu, setMenu] = useState("Menu +");

  const data = useStaticQuery(graphql`
    query MenuQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  // function toggleMenu() {
  //   document.getElementById("sidebar").classList.contains("hidden")
  //     ? document.getElementById("sidebar").classList.remove("hidden")
  //     : document.getElementById("sidebar").classList.add("hidden");
  // }

  // function toggleBtnState() {
  //   menu === "Menu +" ? setMenu("Hide Menu -") : setMenu("Menu +");
  // }

  return (
    // <Headerstyle>
      <div className="Header">
        <div className="navlinks">
          <Sidebar />

          <Link className="fullIdentity" to="/">
            {/* <svg
              width="32"
              height="24"
              viewBox="5 0 8 11"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Page-1" fillRule="evenodd">
                <g id="Artboard" fill="#303034" fillRule="nonzero">
                  <g id="Group-Copy-5">
                    <path
                      d="M3.27149321,3 L8,3 L8,8.01123596 C8,8.43820438 7.94532483,8.83894944 7.83597285,9.21348315 C7.72662087,9.58801685 7.52865905,9.92134685 7.24208145,10.2134831 C7.06108507,10.3932593 6.86689395,10.53558 6.65950226,10.6404494 C6.45211058,10.7453189 6.25037805,10.8239698 6.05429864,10.8764045 C5.85821923,10.9288392 5.67345486,10.9625467 5.5,10.9775281 C5.32654514,10.9925094 5.18325848,11 5.07013575,11 C4.70814299,11 4.35746776,10.9606746 4.01809955,10.8820225 C3.67873133,10.8033704 3.33936821,10.6629224 3,10.4606742 L3.55429864,9.2247191 C3.84087624,9.38951393 4.08785718,9.49812708 4.29524887,9.5505618 C4.50264055,9.60299652 4.74208009,9.62921348 5.01357466,9.62921348 C5.17948801,9.62921348 5.35859632,9.5973786 5.55090498,9.53370787 C5.74321363,9.47003713 5.91100984,9.36329663 6.05429864,9.21348315 C6.3182517,8.92883753 6.45022624,8.53183775 6.45022624,8.02247191 L6.45022624,4.37078652 L3.27149321,4.37078652 L3.27149321,3 Z M13.6521739,7.74285714 L15,7.74285714 L15,11 L10,11 L10,3 L11.4891304,3 L11.4891304,9.60571429 L13.6521739,9.60571429 L13.6521739,7.74285714 Z M0,0 L18,0 L18,14 L0,14 L0,0 Z M1,1 L1,13 L17,13 L17,1 L1,1 Z"
                      id="JL"
                    />
                  </g>
                </g>
              </g>
            </svg> */}
            <h3 className="jl-id">{data.site.siteMetadata.title}</h3>
          </Link>

          <div className="secondary-navlinks">
            <h3>
              <Link to="/">Hi! I'm Julian.</Link>
            </h3>

            <h3>
              <Link to="/college/">Case Studies</Link>{" "}
              <Link className="circled" to="/college/">
                1
              </Link>
              <Link className="circled" to="/nise/">
                2
              </Link>
              <Link className="circled" to="/impakt/">
                3
              </Link>
            </h3>

            {/* <h3>
              <Link to="/interests/">Interests</Link>
            </h3> */}

            {/* <h3>
              <a href="/designprocess.pdf">How I work</a>
            </h3> */}

            <h3>
              <a href="/resume.pdf">Resume</a>
            </h3>

            {/* <h3>
              <Link to="/art/">Art</Link>
            </h3> */}

            {/* <h3>
            <button
              id="btn-menu"
              onClick={() => {
                toggleMenu();
                toggleBtnState();
              }}
            >
              {menu}
            </button>
          </h3> */}

            {/* <div className="secondary-navlinks">
        <h3>
          <Link to="/nise/">Community Recipe Sharing</Link>
        </h3>
        <h3>
          <Link to="/impakt/">Ethical Ecommerce Behavior</Link>
        </h3>
      </div> */}
          </div>
        </div>
      </div>
    // </Headerstyle>
  );
};

export default Header;
